/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKYbGa%7Bborder%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2Pgdg%7Bpadding-top%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbPgdg%7Bpadding-right%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWPgdg%7Bpadding-bottom%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QPgdg%7Bpadding-left%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0adFHs1Y8M%7Bmargin-right%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1RrJLit2nV%7Bvertical-align%3Amiddle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzAyGJ%7Bcolor%3Avar(--ds-text-danger%2C%23ae2e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0WKd3G4z3T%7Bfont-family%3Avar(--ds-font-family-body%2C%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EFQfX%7Bpadding-inline-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wzsVTdnbC%20%3Ediv%7Bmargin-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1CWaDm5zaO%2B._1CWaDm5zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgd8bj%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import React, { Fragment, type KeyboardEvent, type MouseEvent, type MutableRefObject, type Ref, useCallback, useMemo, useRef } from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { ErrorMessage } from '@atlaskit/form/error-message';
import Field from '@atlaskit/form/field';
import { HelperMessage } from '@atlaskit/form/helper-message';
import { MessageWrapper } from '@atlaskit/form/message-wrapper';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import Textfield from '@atlaskit/textfield/text-field';
import type { TextfieldProps as TextFieldProps } from '@atlaskit/textfield/types';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { ConditionalSpotlightTargetWrapper, type ConditionalSpotlightTargetWrapperProps } from './conditional-spotlight-target-wrapper';
import { isRedoEvent, isUndoEvent } from './utils';
const styles = {
  clearTextButton: "_30huDKYbGa _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0adFHs1Y8M _0KLXru66of _1RrJLit2nV",
  requiredIndicatorStyles: "_1UtDYzAyGJ _0WKd3G4z3T _0LQT5EFQfX"
};

/**
 * Overriding text input margin top which design system provides as a default spacer
 * but it gets in the way of our layout
 */
const baseFieldStyles = null;
const newFieldStyles = null;
const RequiredAsterisk = () => {
  return <Box as="span" aria-hidden="true" xcss={styles.requiredIndicatorStyles}>
			*
		</Box>;
};
export type TextInputProps = Omit<TextFieldProps, 'name' | 'value'> & Pick<ConditionalSpotlightTargetWrapperProps, 'spotlightTargetName'> & {
  name: string;
  value: string;
  label?: string;
  // overrides default browser undo behaviour (cmd/ctrl + z) with that function
  onUndo?: () => void;
  // overrides default browser redo behaviour (cm + shift + z / ctrl + y) with that function
  onRedo?: () => void;
  onClear?: (name: string) => void;
  clearLabel?: string;
  error?: React.ReactNode;
  /** Ref to the link picker search input. */
  inputRef?: Ref<HTMLInputElement>;
  helperMessage?: string;
};
export const testIds = {
  urlError: 'link-error',
  clearUrlButton: 'clear-text',
  linkHelperText: 'link-helper-text'
};
export const TextInput = ({
  name,
  label,
  autoFocus,
  onRedo,
  onUndo,
  onKeyDown,
  onClear,
  clearLabel,
  error,
  spotlightTargetName,
  inputRef: inputRefProp,
  isRequired = false,
  helperMessage,
  ...restProps
}: TextInputProps): JSX.Element => {
  const inputRef: MutableRefObject<HTMLInputElement | null> = useRef<HTMLInputElement>(null);
  const handleRef = useCallback((input: HTMLInputElement | null) => {
    if (input) {
      inputRef.current = input;
      if (autoFocus) {
        // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
        input.focus({
          preventScroll: true
        });
      }
    }
  }, [autoFocus]);
  const refs = useMemo(() => ([handleRef, inputRefProp].filter(Boolean) as Ref<HTMLInputElement>[]), [handleRef, inputRefProp]);
  const textfieldRef = useMergeRefs(refs);
  const handleKeydown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (typeof onUndo === 'function' && isUndoEvent(e)) {
      e.preventDefault();
      onUndo();
    } else if (typeof onRedo === 'function' && isRedoEvent(e)) {
      e.preventDefault();
      onRedo();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  }, [onUndo, onRedo, onKeyDown]);
  const handleClear = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClear?.(name);
    inputRef.current?.focus();
  }, [name, onClear]);
  const clearText = restProps.value !== '' && <Tooltip content={clearLabel}>
			<Pressable xcss={styles.clearTextButton} onClick={handleClear} testId={testIds.clearUrlButton}>
				<CrossCircleIcon label={clearLabel || ''} color={"var(--ds-icon-subtle, #505258)"} spacing="spacious" />
			</Pressable>
		</Tooltip>;
  return <div className={ax(["_0wzsVTdnbC _1CWaDm5zaO", "_2sNsIgd8bj"])}>
			<Field label={label} name={name} elementAfterLabel={isRequired ? <RequiredAsterisk /> : undefined}>
				{({
        fieldProps
      }) => {
        return <ConditionalSpotlightTargetWrapper spotlightTargetName={spotlightTargetName}>
							<Fragment>
								<Textfield {...fieldProps} {...restProps} onKeyDown={handleKeydown} ref={textfieldRef} elemAfterInput={clearText} isInvalid={!!error} aria-describedby={`${restProps['aria-describedby']} ${fieldProps.id}-error ${fieldProps.id}-helper`} />
								{fg('platform_navx_3298_message_wrapper') ? <MessageWrapper>
										{helperMessage && <HelperMessage testId={testIds.linkHelperText}>{helperMessage}</HelperMessage>}
										{error && <ErrorMessage testId={testIds.urlError}>{error}</ErrorMessage>}
									</MessageWrapper> : <>
										{helperMessage && <HelperMessage testId={testIds.linkHelperText}>{helperMessage}</HelperMessage>}
										{error && <ErrorMessage testId={testIds.urlError}>{error}</ErrorMessage>}
									</>}
							</Fragment>
						</ConditionalSpotlightTargetWrapper>;
      }}
			</Field>
		</div>;
};